/* eslint-disable import/first */
import React from 'react';

export default function Explore(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7617 17.5022C12.9386 17.5022 12.3635 16.7422 12.3635 15.6533C12.3635 14.3564 13.1457 13.2035 13.7617 13.2035C14.3777 13.2035 15.16 14.3564 15.16 15.6533C15.16 16.7422 14.5849 17.5022 13.7617 17.5022ZM13.7617 11.4897C11.952 11.4897 10.6506 13.616 10.6506 15.6533C10.6506 17.3404 11.5751 18.6826 12.9057 19.088V27.552C12.9057 28.0249 13.2889 28.408 13.7617 28.408C14.2346 28.408 14.6177 28.0249 14.6177 27.552V19.088C15.9475 18.6826 16.8729 17.3404 16.8729 15.6533C16.8729 13.6009 15.5591 11.4897 13.7617 11.4897Z"
        fill="black"
      ></path>
      <mask
        id="mask0_3390_103455"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="5"
        width="28"
        height="30"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66675 5.3335H33.3331V34.5645H6.66675V5.3335Z"
          fill="white"
        ></path>
      </mask>
      <g mask="url(#mask0_3390_103455)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.37933 7.04641H15.9864C17.7269 7.04641 19.1438 8.4633 19.1438 10.2037V32.8517H8.37933V7.04641ZM24.014 7.04641H31.6202V32.8517H20.8567V10.2037C20.8567 8.4633 22.2727 7.04641 24.014 7.04641ZM7.52339 34.5646H32.4763C32.9501 34.5646 33.3332 34.1806 33.3332 33.7077V6.19038C33.3332 5.71661 32.9501 5.3335 32.4763 5.3335H24.0141C22.3501 5.3335 20.8789 6.17261 19.9998 7.44994C19.1207 6.17261 17.6496 5.3335 15.9865 5.3335H7.52339C7.0505 5.3335 6.6665 5.71661 6.6665 6.19038V33.7077C6.6665 34.1806 7.0505 34.5646 7.52339 34.5646Z"
          fill="black"
        ></path>
      </g>
      <mask
        id="mask1_3390_103455"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="5"
        width="28"
        height="30"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66675 34.5646H33.3334V5.3335H6.66675V34.5646Z"
          fill="white"
        ></path>
      </mask>
      <g mask="url(#mask1_3390_103455)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.2818 16.7674H28.1947V12.8545H24.2818V16.7674ZM23.4249 18.4803H29.0516C29.5245 18.4803 29.9076 18.0972 29.9076 17.6243V11.9976C29.9076 11.5247 29.5245 11.1416 29.0516 11.1416H23.4249C22.952 11.1416 22.5698 11.5247 22.5698 11.9976V17.6243C22.5698 18.0972 22.952 18.4803 23.4249 18.4803Z"
          fill="black"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4253 21.9058H29.0511C29.524 21.9058 29.908 21.5218 29.908 21.0489C29.908 20.576 29.524 20.1929 29.0511 20.1929H23.4253C22.9524 20.1929 22.5693 20.576 22.5693 21.0489C22.5693 21.5218 22.9524 21.9058 23.4253 21.9058Z"
          fill="black"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4253 25.3311H29.0511C29.524 25.3311 29.908 24.9471 29.908 24.4742C29.908 24.0022 29.524 23.6182 29.0511 23.6182H23.4253C22.9524 23.6182 22.5693 24.0022 22.5693 24.4742C22.5693 24.9471 22.9524 25.3311 23.4253 25.3311Z"
          fill="black"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4253 28.7568H29.0511C29.524 28.7568 29.908 28.3728 29.908 27.9008C29.908 27.4279 29.524 27.0439 29.0511 27.0439H23.4253C22.9524 27.0439 22.5693 27.4279 22.5693 27.9008C22.5693 28.3728 22.9524 28.7568 23.4253 28.7568Z"
          fill="black"
        ></path>
      </g>
    </svg>
  );
}
